export function mergeInteractionsWithCallsMetadata(interactions, callsMetadata) {
    return interactions.map((interaction) => {
        const callMetadata = callsMetadata.find((call) => call.callServiceCallId === interaction.call.id);
        return Object.assign(Object.assign({}, interaction), { case_id: (callMetadata === null || callMetadata === void 0 ? void 0 : callMetadata.case.id) || '', user: callMetadata === null || callMetadata === void 0 ? void 0 : callMetadata.user });
    });
}
